import React from "react";
import { createRoot } from "react-dom/client";

import { CtaFormIsland } from "../features/cta-form/cta-form-island";
import { CopySnippetIsland } from "../features/copy-snippet/copy-snippet-island";
import { SessionEntryIsland } from "../features/auth-entry/session-entry-island";
import { TemplateFilterIsland } from "../features/template-list/template-filter-island";
import { AppCaseQrIsland } from "../features/app-case-qr/app-case-qr-island";
import { AppCaseFiltersIsland } from "../features/app-case-filters/app-case-filters-island";

type IslandComponent = React.ComponentType<Record<string, unknown>>;

const islandRegistry: Record<string, IslandComponent> = {
  "session-entry": SessionEntryIsland,
  "cta-form": CtaFormIsland,
  "template-filter": TemplateFilterIsland,
  "copy-snippet": CopySnippetIsland,
  "app-case-qr": AppCaseQrIsland,
  "app-case-filters": AppCaseFiltersIsland
};

export function mountDeclaredReactIslands(root?: ParentNode) {
  const searchRoot = root ?? document;
  const mounts = searchRoot.querySelectorAll<HTMLElement>("[data-react-mount], [data-platform-react-island]");
  for (const mountNode of mounts) {
    const mountName = mountNode.dataset.reactMount ?? mountNode.dataset.platformReactIsland;
    if (!mountName) {
      continue;
    }
    const Component = islandRegistry[mountName];
    if (!Component) {
      continue;
    }
    const rawProps = mountNode.dataset.reactProps;
    const props = rawProps ? safeParseProps(rawProps) : {};
    createRoot(mountNode).render(<Component {...props} />);
  }
}

function safeParseProps(value: string): Record<string, unknown> {
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}
